import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Globe } from "lucide-react";
import { Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useThemes } from "../../themes/hooks";
import { PromptFragmentsMultiSelect } from "../../prompt-fragments/components";
import { useCreateProspectionSite } from "../../created-sites/hooks";

interface ISiteGenerationFormValues {
  themeId?: string;
  promptFragmentIds?: number[];
  requirements?: string;
}

interface ISiteGenerationForm {
  customerId: number;
  onGenerated: (createdSiteId: number) => void;
}

export const SiteGenerationForm: React.FC<ISiteGenerationForm> = ({
  customerId,
  onGenerated,
}) => {
  const { data: themesData } = useThemes();
  const { createProspectionSite, loading } = useCreateProspectionSite();
  const [justLaunched, setJustLaunched] = useState(false);

  const form = useForm<ISiteGenerationFormValues>({
    mode: "all",
    defaultValues: { promptFragmentIds: [] },
  });

  const handleGenerate = async () => {
    const { themeId, promptFragmentIds, requirements } = form.getValues();
    const createdSiteId = await createProspectionSite({
      customerId,
      themeId: themeId ? +themeId : null,
      promptFragmentIds: promptFragmentIds?.length ? promptFragmentIds : null,
      requirements: requirements || null,
    });

    if (createdSiteId) {
      setJustLaunched(true);
      onGenerated(createdSiteId);
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Select label="Thème du site" className="w-full" {...form.register("themeId")}>
          <option value="">-</option>
          {themesData?.themes?.results?.map((theme) => (
            <option key={theme.id} value={theme.id}>
              {theme.name}
            </option>
          ))}
        </Select>

        <PromptFragmentsMultiSelect form={form} />

        <Textarea
          label="Exigences du site"
          className="w-full"
          {...form.register("requirements")}
          placeholder="Structure attendue, palette de couleurs, sections obligatoires..."
        />
      </div>

      <div className="w-full mt-4">
        <Button
          variant="secondary"
          onClick={handleGenerate}
          loading={loading}
          disabled={loading || justLaunched}
        >
          <Globe size={16} className="mr-2" />
          {justLaunched ? "Génération lancée" : "Générer le site"}
        </Button>
      </div>
    </div>
  );
};
